import React from 'react';
import './Style/footer.css';
import {isMobile} from '../helpers/utils';

class Footer extends React.Component {
    render() {
        return (
            <div className={isMobile()?`mobile-font-family mobile-alignFooterContent italic`: 'learn-more-web'}>
                 By providing your mobile phone number and saving,  you're confirming that you're the current subscriber and/or customary user of this mobile phone number and you’re consenting to receive text ("SMS") messages from Regions Online or Mobile Banking Services (the "SMS Service") for authentication purposes. By subscribing your mobile phone number for Regions alert services, you’re consenting to alerts that you have subscribed for via SMS messages from the SMS Service. Message frequency depends on account settings. Message and data rates may apply. To cancel the SMS Service, reply STOP.
                 &nbsp; 
                {isMobile() ?
                <span>
                 <a target="_blank"
                className="App-Link" 
                href="https://www.regions.com/digital-banking/digital-services/text-messaging-services">
                    SMS Terms
                </a>
                <br></br>
                <br></br>
                <div>
                You can adjust your device's Do Not Disturb setting to control when these alerts are received.
                </div>
                </span>
                :
                <span>
                 <a 
                target="_blank" 
                rel="noopener noreferrer" 
                className="App-Link" 
                href="https://www.regions.com/digital-banking/text-messaging-services">
                    SMS Terms</a>
                <br></br>
                <br></br>
                Making changes to your device's Do Not Disturb setting will affect when you receive these alerts.
                For more,
                </span>
                }   
                &nbsp;    
                {isMobile()? 
                <div>
                    
                </div>
                    // <a 
                    // target="_blank" 
                    // rel="noopener noreferrer" 
                    // className="App-Link mobile-font-family" 
                    // href="https://www.regions.com/help/online-banking-help/manage-accounts/alerts/how-are-the-do-not-disturb-and-suspend-settings-used-for-mobile-alerts">
                    //  Read the FAQ.</a>
                    :
                    <a 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="App-Link" 
                    href="https://www.regions.com/help/online-banking-help/manage-accounts/alerts/how-do-not-disturb-affects-mobile-tablet-alerts">
                     read the FAQ.</a>
                }
            </div>
        );
    }
}
export default Footer;